// see https://github.com/mszewcz/safe-subscribe/blob/develop/src/safeSubscribe.ts

import { OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject, Subject, Subscription } from 'rxjs';

declare module 'rxjs/internal/Observable' {
  // tslint:disable-next-line: no-unused-declaration
  interface Observable<T> {
    safeSubscribe(target: SafeSubscribable, next?: (value: T) => void, error?: (error: any) => void, complete?: () => void): Subscription;
  }
}

export interface SafeSubscribable extends OnDestroy {
  _subscriptionFromSafeSubscribe?: Subscription;
}

export function safeSubscribe<T>(
  this: Observable<T>,
  target: SafeSubscribable,
  next?: (value: T) => void,
  error?: (error: any) => void,
  complete?: () => void
): Subscription {
  const sub = this.subscribe(next, error, complete);
  if (target) {
    if (!('_subscriptionFromSafeSubscribe' in target)) {
      target._subscriptionFromSafeSubscribe = new Subscription();

      const originalDestroy = target.ngOnDestroy;
      if (!originalDestroy) {
        const cname = (target as any).constructor.name;
        console.warn(`${cname} must implement OnDestroy otherwise Observable<T>.safeSubscribe will have no effect.`);
      }
      target.ngOnDestroy = function () {
        if (originalDestroy && typeof originalDestroy === 'function') {
          originalDestroy.apply(this, arguments as any);
        }
        target._subscriptionFromSafeSubscribe!.unsubscribe();
      };
    }
    target._subscriptionFromSafeSubscribe!.add(sub);
  }
  return sub;
}

Observable.prototype.safeSubscribe = safeSubscribe;
Subject.prototype.safeSubscribe = safeSubscribe;
BehaviorSubject.prototype.safeSubscribe = safeSubscribe;
ReplaySubject.prototype.safeSubscribe = safeSubscribe;
